import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "pie-chart",
  "use": "pie-chart-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"pie-chart\"><path fill-rule=\"evenodd\" d=\"M13 11.365V3c4.5.498 8 4.309 8 8.94 0 1.284-.273 2.5-.756 3.606L13 11.365Zm-2 1.154 8.238 4.756c-1.64 2.221-4.267 3.667-7.238 3.667A9 9 0 0 1 11 3v9.519Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol